<template>
    <div class="w-full bg-white border-2 border-solid border-black p-5 flex">
        <div class="w-full grow mr-5">
            <h1 class="font-bold text-xl mb-2">
                BOOKING <br />RSUD SULTAN FATAH
            </h1>
            <hr />
            <p class="font-semibold mb-5 text-center">
                {{ antrian.booking.FS_KD_TRS }}
            </p>
            <!-- <p>33210350015687/2022KG0285823695</p> -->
            <p class="mt-1 font-bold">{{ antrian.pasien.FS_NM_PASIEN }}</p>
            <p>
                {{ antrian.pasien.FD_TGL_LAHIR }} / {{ antrian.pasien.FS_UMUR }}
            </p>
            <p class="mt-1 font-bold">{{ antrian.poli.FS_NM_LAYANAN }}</p>
            <p>{{ antrian.dokter.FS_NM_DOKTER }} <span style="color: red;">({{ antrian.jadwalPraktikDokter }})</span></p>
            <p class="mt-1 font-bold">
                Tgl.Periksa : {{ antrian.FD_TGL_ANTRIAN }}
            </p>
            <!-- <p>Jam. Periksa: 10.00-15.00</p> -->
            <p class="mt-1 text-2xl font-bold">
                No.Antrian : {{ antrian.FN_NO_URUT }}
            </p>
        </div>
        <div class="w-full">
            <img class="mx-auto ml-auto" :src="antrian.QRCodeLink" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        antrian: Object,
    },
};
</script>
